import React from 'react';

const GameBody = () => {

    return (
        <>
            <div className='container-bodyPending2'>
            <div className='date-league'>
                <span>Time</span>
            </div>
                <div className='container-team'>
                    <div className='col-lg-3 col-md-3 col-sm-3 col-xs-3 col-base'>
                        <span className='name-team'>Team</span>
                    </div>
                    <div className='col-lg-1 col-md-1 col-sm-1 col-xs-1 score col-score2 col-base'>
                        <span>0</span>
                    </div>
                    <div className='container-team col-lg-2 col-md-2 col-sm-2 col-xs-2 score'>
                        <div className='col-lg-7 col-md-7 col-sm-7 col-xs-7 col-base'>
                            <span>12/34</span>
                        </div>
                        <div className='col-lg-5 col-md-5 col-sm-5 col-xs-5 col-score col-base'>
                            <span>0</span>
                        </div>
                    </div>
                    <div className='container-team col-lg-1 col-md-1 col-sm-1 col-xs-1 score'>
                        <div className='col-lg-7 col-md-7 col-sm-7 col-xs-7 col-base'>
                            <span>+104</span>
                        </div>
                        <div className='col-lg-5 col-md-5 col-sm-5 col-xs-5 col-score col-base'>
                            <span>0</span>
                        </div>
                    </div>
                    <div className='container-team col-lg-2 col-md-2 col-sm-2 col-xs-2 score'>
                        <div className='col-lg-7 col-md-7 col-sm-7 col-xs-7 col-base'>
                            <span>Over 7/104</span>
                        </div>
                        <div className='col-lg-5 col-md-5 col-sm-5 col-xs-5 col-score col-base'>
                            <span>0</span>
                        </div>
                    </div>
                    <div className='container-team col-lg-3 col-md-3 col-sm-3 col-xs-3 score'>
                        <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6 col-base'>
                            <span>7/104o-105u</span>
                        </div>
                        <div className='container-team col-lg-6 col-md-6 col-sm-6 col-xs-6'>
                            <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6 col-score col-base'>
                                <span>0</span>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6 col-score col-base'>
                                <span>0</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default GameBody;